import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section id="artigos" className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            Blog & Guias
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950">
            Guias e Artigos{' '}
            <span className="text-accent-500">CSSBuy</span>
          </h2>
          <p className="text-foreground-600 mt-3 text-sm md:text-base max-w-xl mx-auto">
            Aprenda tudo sobre compras internacionais, encontre os melhores produtos e fique por dentro das novidades
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, idx) => (
            <a
              key={article.slug}
              href={`/artigo/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-2xl border border-background-200/70 hover:border-accent-300 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              {/* Article Image */}
              <div className="relative w-full aspect-[16/10] bg-background-100 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx < 6 ? 'eager' : 'lazy'}
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block bg-accent-500 text-white text-[10px] font-semibold px-2.5 py-1 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>

              {/* Article Info */}
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
                <h3 className="text-foreground-950 font-heading font-bold text-base md:text-lg leading-tight mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-3 mb-4 flex-1">
                  {article.description}
                </p>
                <span className="inline-flex items-center gap-1 text-accent-500 text-xs font-medium group-hover:gap-2 transition-all">
                  Ler artigo
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* View All Link */}
        <div className="text-center mt-10">
          <a
            href="/guia-de-compras"
            className="inline-flex items-center gap-2 bg-background-50 border border-background-300/60 text-foreground-700 font-medium px-6 py-3 rounded-full text-sm hover:border-accent-300 hover:text-accent-600 transition-all duration-200 cursor-pointer"
          >
            Ver todos os guias
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}